import { ILoaiChungChiDanhSachMonSysRequest } from "../../../model/request/chuong-trinh-dao-tao/IloaiChungChiDanhSachMonSysRequest";
import { ILoaiChungChiDanhSachMon } from "../../../model/response/chuong-trinh-dao-tao/ILoaiChungChiDanhSachMon";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLoaiChungChiDanhSachMonActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ILoaiChungChiDanhSachMon[],
    LOAD_ERROR: "",

    SYS_START: {} as ILoaiChungChiDanhSachMonSysRequest,
    SYS_SUCCESS: undefined,
    SYS_ERROR: "",
}

export const eLoaiChungChiDanhSachMonActionIds = generateActionTypeIds(eLoaiChungChiDanhSachMonActionsObj, "LOAI_CHUNG_CHI_DANH_SACH_MON");
export type ILoaiChungChiDanhSachMonActionTypes = IGenericActionType<typeof eLoaiChungChiDanhSachMonActionsObj, "LOAI_CHUNG_CHI_DANH_SACH_MON">;